
export const REQUEST_PRODUCTS = "REQUEST_PRODUCTS"
export const SET_PRODUCTS = "SET_PRODUCTS"

const initialState = {
  loading: false,
  products: [],
  error: false,
  errorMessage: ''
}

export const productsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUEST_PRODUCTS:
      return {
        ...state,
        loading: true
      }
    
    case SET_PRODUCTS:
      return {
        ...state,
        loading: false,
        products: payload.map(prod => {
          return {
            ...prod,
            label: prod.product,
            value: prod.id
          }
        })
      }

    default:
      return state
  }
}